import { v4 as uuid } from 'uuid';
import { getWhitelabelTermsAndConditions } from './constants';

export const WhitelabelTerms = ({ handleScroll, containerRef, entityName }) => {
  const currentDate = new Date();
  const day = currentDate.getDate();
  const month = currentDate.toLocaleString('en-us', { month: 'long' });
  const year = currentDate.getFullYear();
  const termsAndConditions = getWhitelabelTermsAndConditions(
    day,
    month,
    year,
    entityName,
  );

  return (
    <div
      className="terms-and-conditions-container"
      onScroll={handleScroll}
      ref={containerRef}
    >
      <div className="section-title">
        {termsAndConditions.WHITELABEL_SERVICE_AGREEMENT.TITLE}
      </div>
      <div className="section-content">
        {termsAndConditions.WHITELABEL_SERVICE_AGREEMENT.PARAGRAPH_1}
      </div>
      <div className="section-content">
        {termsAndConditions.WHITELABEL_SERVICE_AGREEMENT.PARAGRAPH_2}
      </div>
      <div className="section-subtitle" key={uuid()}>
        {termsAndConditions.BACKGROUND.TITLE}
      </div>
      {termsAndConditions.BACKGROUND.CONTENT.PARAGRAPHS.map((paragraph) => (
        <div className="section-content" key={uuid()}>
          {paragraph}
        </div>
      ))}
      {Object.keys(termsAndConditions.TERMS_AND_CONDITIONS.CONTENT).map(
        (element) => (
          <>
            <div className="section-subtitle" key={uuid()}>
              {
                termsAndConditions.TERMS_AND_CONDITIONS.CONTENT[element]
                  .SUBTITLE
              }
            </div>
            {termsAndConditions.TERMS_AND_CONDITIONS.CONTENT[
              element
            ].PARAGRAPHS.map((paragraph) => (
              <div className="section-content" key={uuid()}>
                {paragraph}
              </div>
            ))}
          </>
        ),
      )}
    </div>
  );
};
